import * as React from "react";

import DocImage from "./Image";

interface DocImageGalleryProps extends ImageGalleryNode, EveryNodeArgs {}

export default function DocImageGallery(props: DocImageGalleryProps) {
  const images = props.images.map((image) => {
    const passToEveryNode = {
      currentDocument: props.currentDocument,
      currentVersion: props.currentVersion,
      currentUser: props.currentUser,
      displayState: props.displayState,
      editState: props.editState,

      isGated: props.isGated,

      currentDocumentSetDocumentRelation: props.currentDocumentSetDocumentRelation,
      currentRoleDefinition: props.currentRoleDefinition,
    };

    return (
      <div className="doc-image-gallery-slide" key={image.uid}>
        <DocImage
          {...image}
          {...passToEveryNode}
          inGallery
        />
      </div>
    );
  });

  return (
    <div className="doc-image-gallery">
      <div className="doc-image-gallery-scroller">
        {images}
      </div>
    </div>
  );
}
